import { useCallback } from 'react';

import { formatFileSize } from './functions';

export interface FileWithContent<CT> extends File {
  content?: CT;
}

export interface AcceptedFileItemProps<C> {
  file: FileWithContent<C>;
  disabled?: boolean;
  onDeleteFile: (file: FileWithContent<C>) => void;
}

const AcceptedFileItem = <CF extends string | ArrayBuffer>({
  file,
  disabled,
  onDeleteFile,
}: AcceptedFileItemProps<CF>) => {
  const info = [file.name, file.size ? `- ${formatFileSize(file.size)}` : false].filter(Boolean).join(' ');

  const onDelete = useCallback(
    (evt: React.MouseEvent) => {
      evt.stopPropagation();
      onDeleteFile(file);
    },
    [file, onDeleteFile],
  );

  return (
    <li key={file.name} className="dropzone-file-item">
      {!disabled && (
        <button
          type="button"
          onClick={onDelete}
          className="btn btn-sm btn-box-tool no-padding pull-right"
          title={translate('Clear')}
        >
          <i className="lnr lnr-cross text-danger" />
        </button>
      )}

      <span className="dropzone-file-item-name">{info}</span>
    </li>
  );
};

// eslint-disable-next-line import/no-default-export
export default AcceptedFileItem;
